'use client'
import type { LatLngExpression } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ReactNode } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';



export default function LeafletMapContainer({ children, center }: { children?: ReactNode, center: LatLngExpression }) {

    return (
        <MapContainer
            className='h-full w-full'
            zoomControl={false}
            center={center}
            zoom={13}
            scrollWheelZoom={true}
        >

            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {children}
        </MapContainer>
    );
}

